/* BLK_STICKY_ATC_INBOX_OFFSET_START - Move Shopify Inbox launcher above BLK sticky ATC only. */
(function () {
  if (window.__BLK_STICKY_ATC_INBOX_OFFSET__ === '20260702-v2') return;
  window.__BLK_STICKY_ATC_INBOX_OFFSET__ = '20260702-v2';

  var CHAT_SELECTOR = '#ShopifyChat, inbox-online-store-chat#ShopifyChat, inbox-online-store-chat';
  var BAR_SELECTOR = '[id^="StickyATC-"].sticky-atc.is-visible';
  var scheduled = false;
  var tracked = false;

  function rectOf(element) {
    return element ? element.getBoundingClientRect() : null;
  }

  function visible(element) {
    if (!element) return false;
    var rect = rectOf(element);
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0.05 && rect.width > 0 && rect.height > 0;
  }

  function getBar() {
    var bars = Array.prototype.filter.call(document.querySelectorAll(BAR_SELECTOR), function (bar) {
      if (!visible(bar)) return false;
      var rect = rectOf(bar);
      return rect.height >= 60 && rect.bottom >= window.innerHeight - 8 && rect.top > window.innerHeight * 0.45;
    });
    return bars.sort(function (a, b) {
      return rectOf(b).height - rectOf(a).height;
    })[0] || null;
  }

  function getChat() {
    return document.querySelector(CHAT_SELECTOR);
  }

  function isLauncher(chat) {
    if (!visible(chat)) return false;
    var rect = rectOf(chat);
    return rect.width <= 180 && rect.height <= 160;
  }

  function clearOffset(chat, state) {
    if (!chat) return;
    chat.style.removeProperty('transform');
    chat.removeAttribute('data-blk-sticky-atc-inbox-offset');
    if (state) chat.setAttribute('data-blk-sticky-atc-inbox-state', state);
  }

  function track(offset, barHeight) {
    if (tracked) return;
    tracked = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'blk_sticky_atc_inbox_offset_applied',
      component: 'shopify_inbox',
      reason: 'sticky_atc_visible',
      offset_px: offset,
      bar_height_px: barHeight
    });
  }

  function update() {
    scheduled = false;
    var chat = getChat();
    if (!chat) return;

    if (!isLauncher(chat)) {
      clearOffset(chat, 'expanded');
      return;
    }

    var bar = getBar();
    if (!bar) {
      clearOffset(chat, 'idle');
      return;
    }

    var barRect = rectOf(bar);
    var offset = Math.min(240, Math.max(0, Math.round(barRect.height + 16)));
    chat.style.setProperty('transform', 'translate3d(0, -' + offset + 'px, 0)', 'important');
    chat.setAttribute('data-blk-sticky-atc-inbox-offset', 'active');
    chat.setAttribute('data-blk-sticky-atc-inbox-state', 'launcher');
    track(offset, Math.round(barRect.height));
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }

  function clearBeforeInboxOpens(event) {
    var chat = getChat();
    if (!chat) return;
    if (event.target === chat || (event.composedPath && event.composedPath().indexOf(chat) !== -1)) {
      clearOffset(chat, 'opening');
      window.setTimeout(schedule, 500);
      window.setTimeout(schedule, 1200);
    }
  }

  ['DOMContentLoaded', 'load', 'resize', 'scroll', 'orientationchange'].forEach(function (name) {
    window.addEventListener(name, schedule, { passive: true });
  });
  ['pointerdown', 'touchstart', 'click'].forEach(function (name) {
    document.addEventListener(name, clearBeforeInboxOpens, true);
  });

  if (document.documentElement) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  }

  schedule();
  window.setTimeout(schedule, 500);
  window.setTimeout(schedule, 1500);
  window.setTimeout(schedule, 3000);
})();
/* BLK_STICKY_ATC_INBOX_OFFSET_END */